import { Nav } from "@/components/Nav";
import { DemoBanner } from "@/components/DemoBanner";
import { Link } from "react-router-dom";

const CHAPTERS = [
  {
    n: "01",
    title: "Live Action",
    body: "Directed shoots across fashion, beauty, automotive and sport — built on rehearsed craft: lighting, blocking, and a camera department that knows when to hold and when to move.",
  },
  {
    n: "02",
    title: "Generative AI",
    body: "AI-assisted pipelines for concepting, previs and stylised sequences where a purely physical shoot isn't the fastest or most expressive route to the frame.",
  },
  {
    n: "03",
    title: "Hybrid Direction",
    body: "Live footage and synthetic elements cut together deliberately — practical plates carrying the synthetic work, not the other way around.",
  },
  {
    n: "04",
    title: "CGI & VFX",
    body: "Full CG builds and compositing for products, vehicles and worlds that don't exist yet, rendered with the same attention to light as a live set.",
  },
];

export default function Studio() {
  return (
    <div className="min-h-screen bg-[#101010] text-[#F5F5F0]" data-testid="studio-page">
      <DemoBanner />
      <Nav />

      <div className="max-w-4xl mx-auto px-4 sm:px-8 pt-12 sm:pt-16 pb-10 sm:pb-12">
        <p className="font-mono text-sm uppercase tracking-widest text-[#CCFF00] mb-3">Studio</p>
        <h1 className="font-mono text-xl sm:text-2xl tracking-tight leading-snug text-[#F5F5F0]">
          A Mumbai film studio for four ways of making an image.
        </h1>
        <p className="mt-5 text-sm sm:text-base leading-relaxed text-[#c8c8c0] max-w-xl">
          EiPi Media is a film production studio based in Mumbai. We work across live action, generative AI, hybrid
          and CGI filmmaking — choosing whichever combination gets a brand's idea on screen with the most craft and
          the least compromise.
        </p>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-8 pb-16 sm:pb-20 divide-y divide-[#2A2A2A]">
        {CHAPTERS.map((c) => (
          <div key={c.n} data-testid={`studio-chapter-${c.n}`} className="py-7 sm:py-8 grid grid-cols-[auto_1fr] gap-4 sm:gap-8">
            <span className="text-sm text-[#555550]">{c.n}</span>
            <div>
              <h2 className="text-base sm:text-lg tracking-tight mb-2 text-[#F5F5F0]">{c.title}</h2>
              <p className="text-sm sm:text-base leading-relaxed text-[#888880] max-w-xl">{c.body}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="border-y border-[#2A2A2A] overflow-hidden py-5 sm:py-6" aria-hidden="true" data-testid="studio-marquee">
        <div
          className="marquee-track flex whitespace-nowrap font-mono uppercase text-xl sm:text-2xl tracking-tight text-transparent"
          style={{ WebkitTextStroke: "1px #CCFF00" }}
        >
          <span className="mr-12">LIVE ACTION — GENAI — HYBRID — CGI — MUMBAI — LIVE ACTION — GENAI — HYBRID — CGI — MUMBAI —</span>
          <span className="mr-12">LIVE ACTION — GENAI — HYBRID — CGI — MUMBAI — LIVE ACTION — GENAI — HYBRID — CGI — MUMBAI —</span>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-8 py-8 sm:py-10">
        <Link to="/demo-showcase" data-testid="studio-demo-showcase-link" className="text-sm text-[#555550] hover:text-[#CCFF00] transition-colors">
          View the original stock demo showcase →
        </Link>
      </div>
    </div>
  );
}
